<template>
  <div class="panel-header panel-header-sm" />
</template>
<script>
export default {};
</script>
<style></style>
